$(document).ready(function() {
    /*Made by Fouad Fawzi*/
    // Date and  time
    // alert();
    setInterval( function() {
        var hours = new Date().getHours();
        $(".hours").html(( hours < 10 ? "0" : "" ) + hours );
    }, 1000);
    setInterval( function() {
        var minutes = new Date().getMinutes();
        $(".min").html(( minutes < 10 ? "0" : "" ) + minutes);
    },1000);
    setInterval( function() {
        var seconds = new Date().getSeconds();
        $(".sec").html(( seconds < 10 ? "0" : "" ) + seconds );
    },1000);
    setInterval( function() {
        var d = new Date();

        var month = d.getMonth()+1;
        var day = d.getDate();

        var output = d.getFullYear() + '/' +
            ((''+month).length<2 ? '0' : '') + month + '/' +
            ((''+day).length<2 ? '0' : '') + day;
        $('.date-div').html(output);
    },(1000));

    //icon toggle by Fouad

    $('a .link-toggle').click(function() {
         //$(this).slideToggle('300');
        alert('');
        $(this).find('i').toggleClass('fa-plus-circle').toggleClass('fa-minus-circle');
    });
//    tooltip tool by Fouad
        $(".tooltip1").tooltipster({
            interactive:true,
            theme: 'tooltipster-light',
            content: $('#tooltip_content'),
            contentCloning: false,
            Default: false,
            trigger: 'custom',
            triggerOpen: {
                click: true,
                tap: true
            },
            triggerClose: {
                mouseleave: true,

                // originleave: true
                // touchleave: true
            },
            functionInit: function(instance, helper){

                // parse the content
                var content = instance.content(),
                    people = JSON.parse(content),
                    // and use it to make a sentence
                    newContent = 'We have ' + people.length + ' people today. Say hello to ' + people.join(', ');

                // save the edited content
                instance.content(newContent);
            }


        });
    $(".sidebartoggler").on('click', function() {
        if ($("body").hasClass("mini-sidebar")) {
            $("body").trigger("resize");
            $("body").removeClass("mini-sidebar");
            $('.navbar-brand span').show();

        } else {
            $("body").trigger("resize");
            $("body").addClass("mini-sidebar");
            $('.navbar-brand span').hide();

        }
    });
//validator
//     $('#userForm').validator();



});


// WEBPACK FOOTER //
// src/assets/js/custom-me.js